import React, { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  Box,
  Button,
  TextField,
  Typography,
} from '@mui/material';
import {
  DigitalSection,
} from '../../redux/types';

type Props = {
  selectedSection?: DigitalSection;
  updateSection: (section: DigitalSection) => void;
  notificationAction?: (message: string | React.ReactElement) => void;
  showErrorNotification?: (val: string) => void;
  submissionExist?: boolean;
}

const DigitalScoreEditor: React.FC<Props> = ({
  selectedSection,
  updateSection,
  submissionExist,
  notificationAction,
  showErrorNotification,
}: Props) => {
  const [secScore, setSecScore] = useState<number>(0);

  useEffect(() => {
    if (selectedSection?.passScore) {
      setSecScore(selectedSection.passScore);
    } else {
      setSecScore(0);
    }
  }, [selectedSection]);

  const onChangeSecScore = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    const numValue = parseInt(value || '0', 10);
    setSecScore(numValue);
  };

  const onSaveSectionScore = () => {
    if (submissionExist) {
      showErrorNotification?.('Cannot edit score, submission exists');
      return;
    }

    if (secScore && selectedSection) {
      updateSection({ ...selectedSection, passScore: secScore });
      if (notificationAction) {
        notificationAction(<FormattedMessage id="genericSaveMessage" />);
      }
    }
  };

  return (
    <Box>
      <Typography variant="h4" sx={{ my: 2, ml: 2 }}>Scores</Typography>
      <Box display="flex">
        <TextField variant="outlined" label="Antibody passing score" size="small" sx={{ my: 2, ml: 2 }} type="number" value={secScore} onChange={onChangeSecScore} />
        <Button variant="outlined" color="tertiary" sx={{ my: 2, ml: 2 }} onClick={onSaveSectionScore}>Save</Button>
      </Box>
    </Box>
  );
};

export default DigitalScoreEditor;
